import { PmsColor } from '@midocean/webapps-shared-domain';
import { AnnotationShape } from '../../typings/common';
import { NotificationResult, ValidatorColor } from '../../typings/notification';

export const spotColorsValidator = (
  shape: AnnotationShape,
  printPositionName: string
): NotificationResult | undefined => {
  const validatorName = 'spotColorsValidator';

  if (shape.kind === 'Logo') {
    const { pmsColorsInPngFile } = shape;

    const nonOriginalSpotColorsDetected = pmsColorsInPngFile.filter(
      (p) => p.isOriginalSpotColor === false
    ) as PmsColor[];

    const validatorColor: ValidatorColor =
      nonOriginalSpotColorsDetected.length > 0 ? 'Red' : 'Green';

    return {
      shapeId: shape.id,
      validatorColor,
      validatorName,
      printPositionName,
      message: '',
    };
  }
};
